import { defineAction } from '~/prix'
import { z } from 'zod'
import inseminationCreateAction from './inseminationCreate.action.json' with { type: 'json' }
import { inseminationObject } from '../inseminationObject'
import { materialObject } from '../../material/materialObject'

const inseminationCreateDefinition = defineAction({
  ...inseminationCreateAction,

  input: inseminationObject
    .pick({
      id: true,
      programId: true,
      programDosage: true,
      earringNumber: true,
      inseminatorId: true,
      citizenId: true,
      residenceId: true,
      isRepetition: true,
      semenBatchId: true,
    })
    .partial({ id: true })
    .extend({
      materials: z
        .array(z.object({ id: materialObject.shape.id, quantity: z.number().positive().int() }))
        .min(1),
    }),
  output: z.object({ id: inseminationObject.shape.id }),
})

export default inseminationCreateDefinition
